module.exports = __webpack_public_path__ + "static/media/bamburgh-react-commerce-application-reactstrap-pro.a7d31897.jpg";